module.exports = __webpack_public_path__ + "img/shoppyli.db7c7537.jpg";